import { useState, useEffect } from "react";
import {
  PrintOrderNumberLabel, PrintOrderNumberLabelsBatch,
  PrintSampleLabel,
  PrintCheckInLabel,
  sampleInfo,
} from "../../../services/barcodeService";
import {
  CreateOrder,
  GetSampleIdsForOrderSamples,
} from "../../../services/orderService";
import NewOrderFormNew from "../new-design/NewOrderFormNew";
import { appInsights } from "../../../services/appInisights";
import { NotificationManager } from "react-notifications";
import {
  SetLastUser,
  GetEtkKits,
} from "../../../services/usersService";
import { InputAdornment } from "@mui/material";
import { getFormattedDateTime } from "../../../services/dateService";
import CommonLoader from "../../../vlp/components/common/CommonLoader";
import ClientSelectorDialog from "../../../vlp/components/common/ClientSelectorDialog";
import UserSelectorDialog from "../../../vlp/components/common/UserSelectorDialog";
import { Grid, TextField, Button, Box, Tooltip } from "@mui/material";
import {
  Business as BusinessIcon,
  Edit as EditIcon,
  Person as PersonIcon,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";

let model = {
  orderNumber: null,
  accountNumber: "",
  orderType: "",
  sampleType: "",
  sampleCount: 0,
  dateReceived: null,
  payType: "",
};

export default function NoBarcodeMainNew(props) {
  const [modelInstance, setModelInstance] = useState(model);
  const [currentUser, setCurrentUser] = useState();
  const [time, setTime] = useState(getFormattedDateTime(new Date()));
  const [order, setOrder] = useState();
  const [orders, setOrders] = useState([]);
  const [account, setAccount] = useState("");
  const [accountValid, setAccountValid] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [etkKits, setEtkKits] = useState(null);
  const [payType, setPayType] = useState("");
  const [loading, setLoading] = useState(false);
  const [accountType, setAccountType] = useState(null);

  // States for ClientSelectorDialog
  const [clientDialogOpen, setClientDialogOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [errors, setErrors] = useState({});

  // States for UserSelectorDialog
  const [userSelectorOpen, setUserSelectorOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    async function loadData() {
      setLoading(true);
      try {
        const kits = await GetEtkKits();
        setEtkKits(kits);
      } catch (err) {
        NotificationManager.error("Error getting initial data from the API");
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  // Handle client selection from dialog
  const handleClientSelect = (client) => {
    if (client) {
      setSelectedClient(client);
      setAccount(client.accountNumber);
      setAccountValid(true);
      setAccountType(client.clientType);

      // Clear any previous account-related errors
      setErrors((prev) => ({
        ...prev,
        accountNumber: "",
      }));
    }
  };

  // Handle user selection from dialog
  const handleUserSelect = (user) => {
    if (user) {
      setSelectedUser(user);
      setCurrentUser(user.operator);
      SetLastUser(user.operator);
    }
  };

  const handleSubmit = async (model) => {
    try {
      setLoading(true);
      setPayType(model.payType);
      model.accountNumber = account;
      setModelInstance(model);
      let response = await CreateOrder(model);
      if (model.payType !== "" && model.orderType === "ETK") {
        setOrders(response);
        NotificationManager.success("Orders created", response.length);
        setOrder(response[0]);
      } else {
        setOrder(response);
        NotificationManager.success("Order created", response.orderNumber);
      }
      setSubmitSuccess(true);
    } catch (error) {
      appInsights.trackEvent({
        name: "Error Creating New Order",
        properties: {
          message: "Error creating a new order from NoBarcodeMain.js",
          error: error,
        },
      });
      appInsights.trackException({ exception: error });
      NotificationManager.error(
        "Unable to create order. Error " + error,
        "Error Submitting"
      );
    } finally {
      setLoading(false);
    }
  };

  const printSampleBarcodes = async () => {
    if (!modelInstance) return;
    try {
      var sampleIds = GetSampleIdsForOrderSamples(order);

      let sampleInfos = [];

      sampleIds.forEach((id) => {
        let model = Object.create(sampleInfo);

        model.sampleId = id;
        model.sampleType = modelInstance.sampleType;
        sampleInfos.push(model);
      });

      await PrintSampleLabel(sampleInfos);
    } catch (error) {
      appInsights.trackEvent({
        name: "Error Printing Labels for new order",
        properties: {
          message: "Error Printing Labels for new order from NoBarcodeMain.js",
          error: error,
        },
      });
      appInsights.trackException({ exception: error });
      NotificationManager.error(
        "Unable to print labels for order. Error " + error,
        "Error Printing"
      );
    }
  };

  const printCheckIn = async () => {
    try {
      await PrintCheckInLabel(currentUser, new Date(time));
    } catch (error) {
      appInsights.trackEvent({
        name: "Error Printing Labels for new order",
        properties: {
          message: "Error Printing Labels for new order from NoBarcodeMain.js",
          error: error,
        },
      });
      appInsights.trackException({ exception: error });
      NotificationManager.error(
        "Unable to print labels for order. Error " + error,
        "Error Printing"
      );
    }
  };

  const printOrderNumber = async () => {
    try {
      await PrintOrderNumberLabel(
        order.orderNumber,
        "orderNumberQRCode",
        payType
      );
    } catch (error) {
      NotificationManager.error(
        "Unable to print labels for order. Error " + error,
        "Error Printing"
      );
    }
  };

  // const printOrderNumberQRLabels = async () => {
  //   const sortedOrders = [...orders].sort(
  //     (a, b) => b.orderNumber - a.orderNumber
  //   );
  //   sortedOrders.forEach(async (order) => {
  //     try {
  //       await PrintOrderNumberLabel(
  //         order.orderNumber,
  //         "orderPayQRBarcode",
  //         payType,
  //         modelInstance.sampleType
  //       );
  //     } catch (error) {
  //       NotificationManager.error(
  //         "Unable to print labels for order. Error " + error,
  //         "Error Printing"
  //       );
  //     }
  //   });
  // };

  const printOrderNumberQRLabels = async () => {
    try {
      const sortedOrders = [...orders].sort(
        (a, b) => b.orderNumber - a.orderNumber
      );

      // Extract order numbers for batch processing
      const orderNumbers = sortedOrders.map((order) => order.orderNumber);

      // Call the new batch endpoint
      await PrintOrderNumberLabelsBatch(
        orderNumbers,
        "orderPayQRBarcode",
        payType,
        modelInstance.sampleType
      );

      NotificationManager.success(
        "All labels printed successfully",
        "Print Complete"
      );
    } catch (error) {
      NotificationManager.error(
        "Unable to print labels. Error: " + error.message,
        "Error Printing"
      );
    }
  };


  const handleReset = () => {
    setModelInstance(model);
    setOrder();
    setAccountValid(account ? true : false);
    setSubmitSuccess(false);
    // Reset client selection states
    setSelectedClient(null);
    setAccount("");
    setAccountType(null);
    setErrors({});
  };

  return (
    <>
      <div className="vlp-component-container" style={{ marginRight: "15px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span className="title">
            {modelInstance.orderNumber ?? "New Order"}
          </span>

          <div style={{ display: "flex", gap: "12px" }}>
            <Tooltip
              title="Create multiple ETK orders at once and automatically download them as an Excel file. Optional QR images and ZPL label files can also be generated."
              arrow
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/vlp/new-bulk-order")}
              >
                Bulk Orders
              </Button>
            </Tooltip>

            <Tooltip title="Reserve a block of order numbers for a laboratory account without creating full orders. Useful for pre-allocating orders for lab processing." arrow>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/vlp/reserve-order")}
              >
                Reserve Orders
              </Button>
            </Tooltip>
          </div>
        </div>

        <hr />
        <div >
          <Grid container spacing={2}>
            {/* User Field - Updated to use UserSelectorDialog */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="User"
                value={
                  selectedUser
                    ? `${selectedUser.operator.trim()} - ${selectedUser.aliasName.trim()}`
                    : "Click to select user"
                }
                size="small"
                fullWidth
                onClick={() => setUserSelectorOpen(true)}
                InputProps={{
                  readOnly: true,
                  style: { cursor: "pointer" },
                  startAdornment: selectedUser ? null : (
                    <InputAdornment position="start" variant="outlined">
                      <PersonIcon color="primary" />
                    </InputAdornment>
                  ),
                  endAdornment: selectedUser ? (
                    <InputAdornment position="end">
                      <EditIcon color="primary" sx={{ fontSize: 20 }} />
                    </InputAdornment>
                  ) : null,
                }}
                helperText={
                  errors.accountNumber ||
                  (selectedUser
                    ? "Click to change user"
                    : "Click to select user")
                }
                error={!!errors.accountNumber}
              />
            </Grid>

            {/* Account Selection - Updated to use ClientSelectorDialog */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="Account Number"
                // value={selectedClient ? account : "Click to select client"}
                value={
                  selectedClient
                    ? `${account.trim()} - ${selectedClient.clientName.trim()}`
                    : "Click to select client"
                }
                size="small"
                fullWidth
                onClick={() => setClientDialogOpen(true)}
                InputProps={{
                  readOnly: true,
                  style: { cursor: "pointer" },
                  startAdornment: selectedClient ? null : (
                    <InputAdornment position="start">
                      <BusinessIcon color="primary" />
                    </InputAdornment>
                  ),
                  endAdornment: selectedClient ? (
                    <InputAdornment position="end">
                      <EditIcon color="primary" sx={{ fontSize: 20 }} />
                    </InputAdornment>
                  ) : null,
                }}
                helperText={
                  errors.accountNumber ||
                  (selectedClient
                    ? "Click to change client"
                    : "Click to select a client")
                }
                error={!!errors.accountNumber}
              />
            </Grid>

            {/* Time Field */}
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Time"
                type="datetime-local"
                size="small"
                value={time}
                onChange={(e) => setTime(getFormattedDateTime(e.target.value))}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>

          <Box sx={{ marginTop: 2 }}>
            {accountValid && (
              <NewOrderFormNew
                model={modelInstance}
                kits={etkKits}
                accountNumber={account}
                onSubmit={handleSubmit}
                handlePrint={printSampleBarcodes}
                handlePrintOrderNumber={printOrderNumber}
                handlePrintOrderNumberQRLabels={printOrderNumberQRLabels}
                handleCheckInPrint={printCheckIn}
                orderNumber={order?.orderNumber}
                accountType={accountType}
              />
            )}
          </Box>

          {submitSuccess && (
            <Grid
              container
              spacing={2}
              sx={{ marginTop: 2, justifyContent: "flex-end" }}
            >
              <Grid item>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          )}
        </div>

        <CommonLoader loading={loading} />
      </div>

      {/* Client Selector Dialog */}
      <ClientSelectorDialog
        open={clientDialogOpen}
        onClose={() => setClientDialogOpen(false)}
        onSelect={handleClientSelect}
        multiSelect={false}
      />

      {/* User Selector Dialog */}
      <UserSelectorDialog
        open={userSelectorOpen}
        onClose={() => setUserSelectorOpen(false)}
        onSelect={handleUserSelect}
        multiSelect={false}
        filter="SHIPPING"
      />
    </>
  );
}
